import * as React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { getlistGestionDatosBancariosSellersTesoreria, updateEstadoBancarioCbuSellerApi } from '../../api/axios';
import { getEstadoBancarioCbu } from '../../utilities/Seller/EstadoBancarioCbuSeller';
import BigSpinner from '../General/BigSpinner';
import { DropDownArrow, customStyle } from '../../template/CustomStyle';

class GestionDatosBancarios extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listaDatosBancarios: [],
            isLoading: true,
            estado: null,
            estadosOptions: [
                { value: 1, label: "Pendiente" },
                { value: 2, label: "Aprobado" },
                { value: 3, label: "Rechazado" },
                { value: null, label: "Todos" } //Todos: trae pendientes y aprobados
            ],
            //motivos: ["CBU incorrecto", "Datos inválidos", "Banco no coincide", "Otro motivo"],
            //motivoSeleccionado: {}
        };
    }

    componentDidMount() {
        const { userType } = this.props;

        if (userType.isTesoreria) {
            this.setState(
                { estado: { value: 1, label: "Pendiente" } },
                () => this.cargarListaDatosBancarios()
            );
        } else {
            this.setState(
                { estado: { value: null, label: "Todos" } },
                () => this.cargarListaDatosBancarios()
            );
        }
    }

    cargarListaDatosBancarios = async () => {
        const { estado } = this.state;

        try {
            let datosBancarios = [];

            if (!estado || estado.value === null) {
                const requests = [1, 2, 3].map(e =>
                    getlistGestionDatosBancariosSellersTesoreria({ estado: e })
                );

                const responses = await Promise.all(requests);
                responses.forEach(res => {
                    if (res && res.datosBancarios) {
                        datosBancarios = [...datosBancarios, ...res.datosBancarios];
                    }
                });
            } else {
                const request = {
                    estado: estado.value
                };
                const datos = await getlistGestionDatosBancariosSellersTesoreria(request);
                if (datos && datos.datosBancarios) {
                    datosBancarios = datos.datosBancarios;
                }
            }

            this.setState({
                listaDatosBancarios: datosBancarios,
                isLoading: false
            });
        } catch (error) {
            console.error(error);
            toast.error("No se pudieron cargar los datos bancarios.");
            this.setState({ isLoading: false });
        }
    };

    renderEstado = (estado) => {
        const texto = getEstadoBancarioCbu(estado).toUpperCase();
        let clase = "badge bg-dark";

        switch (texto) {
            case "PENDIENTE":
                clase = "badge bg-secondary";
                break;
            case "APROBADO":
                clase = "badge bg-success";
                break;
            case "RECHAZADO":
                clase = "badge bg-danger";
                break;
            default:
                clase = "badge bg-dark";
        }

        return <span className={clase}>{texto}</span>;
    };

    //cambiarMotivo = (id, value) => {
    //    this.setState(prev => ({
    //        motivoSeleccionado: { ...prev.motivoSeleccionado, [id]: value }
    //    }));
    //};

    aceptar = async (id) => {
        try {
            const request = {
                id: id,
                estado: 2
            };

            await updateEstadoBancarioCbuSellerApi(request);
            toast.success("Datos Bancarios Aprobados");
            await this.cargarListaDatosBancarios();

        } catch (error) {
            toast.error("No se pudieron aprobar los datos bancarios");
        }
    };

    rechazar = async (id) => {
        //if (!this.state.motivoSeleccionado[id]) {
        //    toast.error("Debe seleccionar un motivo");

        //}

        try {
            const request = {
                id: id,
                estado: 3
            };

            await updateEstadoBancarioCbuSellerApi(request);
            toast.success("Datos Bancarios Rechazados");
            await this.cargarListaDatosBancarios();

        } catch (error) {
            toast.error("No se pudieron rechazar los datos bancarios.");
        }
    };

    handleChangeEstado = (selected) => {
        this.setState({ estado: selected }, () => {
            this.cargarListaDatosBancarios();
        });
    };

    //buscar = () => {
    //    this.cargarListaDatosBancarios();
    //};

    //limpiar = () => {


    //    this.setState(
    //        { estado: null },
    //        () => this.cargarListaDatosBancarios()
    //    );
    //};

    render() {
        const { listaDatosBancarios, isLoading } = this.state;

        return (
            <div className="container-fluid mt-4">

                <div className="col-12">
                    <h3 className="text-themecolor color-rojo-megatone">Datos Bancarios Sellers</h3>

                    <div className="row align-items-end mt-2">

                        <div className="col-12 col-sm-5">
                            <label className="label-oscura">Estado</label>
                            <Select
                                name="estado"
                                options={this.state.estadosOptions}
                                value={this.state.estado}
                                onChange={this.handleChangeEstado}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                styles={customStyle}
                            />
                        </div>

                        {/*<div className="col-12 col-sm-3 mt-3 mt-sm-0">*/}
                        {/*    <button*/}
                        {/*        className="btn btn-sm btn-grey me-2"*/}
                        {/*        onClick={this.buscar}*/}
                        {/*        disabled={this.props.userType.isTesoreria}*/}
                        {/*    >*/}
                        {/*        Buscar*/}
                        {/*    </button>*/}

                        {/*    <button*/}
                        {/*        className="btn btn-sm btn-grey"*/}
                        {/*        onClick={this.limpiar}*/}
                        {/*        disabled={this.props.userType.isTesoreria}*/}
                        {/*    >*/}
                        {/*        Limpiar*/}
                        {/*    </button>*/}
                        {/*</div>*/}

                    </div>
                </div>

                <br />

                {isLoading ? (
                    <BigSpinner />
                ) : listaDatosBancarios.length === 0 ? (
                    <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                        No se encontraron datos
                    </h5>
                ) : (
                    listaDatosBancarios.map(item => (
                        <div
                            key={item.id}
                            className="list-group-item hover-background-color mb-1 p-1"
                            style={{ background: "#fff" }}
                        >
                            <div className="row align-items-center">

                                <div className="col-md-3">
                                    <strong>{item.seller}</strong><br />
                                    <small>{item.cuit}</small>
                                </div>

                                <div className="col-md-4">
                                    <div><strong>Número de cuenta:</strong> {item.nroCuenta}</div>
                                    <div><strong>Tipo:</strong> {item.tipoCuenta}</div>
                                    <div><strong>CBU:</strong> {item.cbu}</div>
                                    <div><strong>Banco:</strong> {item.banco}</div>
                                </div>

                                <div className="col-md-2">
                                    {this.renderEstado(item.estado)}
                                </div>

                                {this.props.userType.isTesoreria && (
                                    <div className="col-md-3 d-flex gap-2">
                                        <button
                                            className="btn btn-sm btn-green"
                                            onClick={() => this.aceptar(item.id)}
                                        >
                                            ACEPTAR
                                        </button>

                                        <button
                                            className="btn btn-sm background-rojo-megatone waves-light mx-1"
                                            onClick={() => this.rechazar(item.id)}
                                        >
                                            RECHAZAR
                                        </button>
                                    </div>
                                )}

                            </div>
                        </div>
                    ))
                )}

            </div>

        );
    }
}

const mapStateToProps = state => ({
    userType: state.general.userType,
});

export default connect(mapStateToProps)(GestionDatosBancarios);